import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { useEnabledFlagList } from '@wix/da-react-context/pkg/flags/hooks';
import { InitResponse } from '../redux/types';
import { SubmitFormContext } from '../context';

interface ConditionalHookContext {
  deviation?: PapiDeviation;
  tiers?: PapiDeviation[];
  displayOptions?: InitResponse['displayOptions'];
  initResponse?: InitResponse;
  isEdit?: boolean;
  features: string[];
}

export function withConditionalField<Props>(
  Field: React.ComponentType<Props>,
  conditionalHook: (ctx: ConditionalHookContext) => boolean
) {
  return (props: Props & React.JSX.IntrinsicAttributes) => {
    const { initResponse, isEdit } = useContext(SubmitFormContext) || {};
    const features = useEnabledFlagList();
    const shouldRender = conditionalHook({
      // TODO: Clean up hocs using these shortcuts and make them use initResponse instead
      deviation: initResponse?.deviation,
      tiers: initResponse?.tiers,
      displayOptions: initResponse?.displayOptions,
      initResponse,
      isEdit,
      features,
    });
    if (shouldRender) {
      return <Field {...props} />;
    }
    return null;
  };
}
